import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { SocialLink } from '../../footer/AdditionalFooterSections/FooterSocialLinks';
import { Link } from '../../../../partials/link/Link';
import { useTheme } from '../../../../../theming/useTheme';
import { BaseUnit } from '../../../../../theming/baseUnitDefinition';
import { MEDIA_BREAKPOINTS } from '../../../../../mediaQueries.const';
import { AnimationDirection, AnimationDirectionType } from '../menuAnimations.util';

interface SocialLinksProps {
  socialLinks: SocialLink[];
  verticalGapInLargeScreen: number;
  verticalGapInMediumScreen: number;
  menuAnimation: AnimationDirectionType;
  reduceHeightAnimationDuration: number;
}

const getStyles = (baseUnit: BaseUnit, numSocialLinks: number, verticalGapInLargeScreen: number, verticalGapInMediumScreen: number, reduceHeightAnimationDuration: number, menuAnimation: AnimationDirectionType) => StyleSheet.create({
  wrapper: {
    gridTemplateColumns: `repeat(${numSocialLinks}, 1fr)`,
    alignItems: 'center',
    textAlign: 'center',
    [MEDIA_BREAKPOINTS.large]: {
      display: 'grid',
      paddingLeft: `${baseUnit * verticalGapInLargeScreen}px`,
      gridColumnGap: `${baseUnit * verticalGapInLargeScreen}px`,
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: 'grid',
      paddingLeft: `${baseUnit * verticalGapInMediumScreen}px`,
      gridColumnGap: `${baseUnit * verticalGapInMediumScreen}px`,
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: 'none',
    },
  },
  img: {
    height: menuAnimation === AnimationDirection.UP ? `${baseUnit * 0.5}px` : `${baseUnit * 0.75}px`,
    transition: `${reduceHeightAnimationDuration}ms`,
  },
});

export const SocialLinks: React.FunctionComponent<SocialLinksProps> = props => {
  const { socialLinks, verticalGapInLargeScreen, verticalGapInMediumScreen, reduceHeightAnimationDuration, menuAnimation } = props;
  const { baseUnit } = useTheme();
  const styles = getStyles(baseUnit, socialLinks.length, verticalGapInLargeScreen, verticalGapInMediumScreen, reduceHeightAnimationDuration, menuAnimation);
  return (
    <div className={css(styles.wrapper)}>
      {
        socialLinks.map((link, index) => (
          <Link href={link.href} key={index} target="_blank">
            <img className={css(styles.img)} src={link.src} alt={link.alt} />
          </Link>
        ))
      }
    </div>
  );
};
